<template>
    <div class="page page-my">
        <div class="header"
             v-if="!isVisitor">
            <div class="user-info">
                <div class="avatar">
                    <img class="avatar-img"
                         v-if="userInfo"
                         :src="userInfo.headImgUrl" />
                    <img class="avatar-img"
                         v-else
                         src="~@/assets/imgs/not_login.png" />
                </div>
                <div class="h-user">
                    <div class="user-name">
                        {{userInfo.nickname}}
                        <span class="user-level" v-if="userInfo.levelDesc">
                            {{userInfo.levelDesc}}
                        </span>
                    </div>
                    <div class="user-id">ID：{{userInfo.id}}</div>
                </div>
            </div>
            <div class="earnings"
                 v-if="isSupplier">
                <div class="earnings-item">
                    <div class="earnings-item-value">{{money.total||0}}</div>
                    <div class="earnings-item-title">累计预估</div>
                </div>
                <div class="earnings-item">
                    <div class="earnings-item-value">{{money.settleOfToday||0}}</div>
                    <div class="earnings-item-title">今日预估</div>
                </div>
            </div>
        </div>
        <div class="header"
             v-else>
            <div class="user-info">
                <div class="avatar">
                    <img src="~@/assets/imgs/not_login.png"
                         class="avatar-img" />
                </div>
                <div class="h-user"
                     @click="userLogin">登录/注册</div>
            </div>
        </div>
        <div class="view20"></div>
        <template v-if="isSupplier">
            <div class="order-title">
                商家订单
                <div class="order-all"
                     bindtap="businessOrderTwo">
                    全部订单
                    <img class="order-all-you"
                         src="~@/assets/imgs/my_you.png" />
                </div>
            </div>
            <div class="order-list">
                <div class="order-item"
                     data-type=""
                     bindtap="businessOrder">
                    <img src="~@/assets/imgs/my_qiang.jpg"
                         class="order-item-image" />
                    <div class="order-item-title">待抢单</div>
                    <div class="order-item-num"
                         v-if="supplierObj.grableCount&&(supplierObj.grableCount > 0)">
                        {{supplierObj.grableCount}}
                    </div>
                </div>
                <div class="order-item"
                     data-type="5"
                     bindtap="businessOrderTwo">
                    <img src="~@/assets/imgs/my_daic.png"
                         class="order-item-image" />
                    <div class="order-item-title">待出票</div>
                    <div class="order-item-num"
                         v-if="supplierObj.winCount && (supplierObj.winCount > 0)">
                        {{supplierObj.winCount}}
                    </div>
                </div>
            </div>
            <div class="view20"></div>
        </template>
        <div class="order-title">
            我的订单
            <div class="order-all"
                 @click="toOrder(0)">
                全部订单
                <img class="order-all-you"
                     src="~@/assets/imgs/my_you.png" />
            </div>
        </div>
        <div class="order-list">
            <div class="order-item"
                 @click="toOrder(2)">
                <img src="~@/assets/imgs/my_daif.png"
                     class="order-item-image" />
                <div class="order-item-title">待出票</div>
                <div class="order-item-num"
                     v-if="orderNum.waitDraw&&(orderNum.waitDraw > 0)">
                    {{orderNum.waitDraw}}
                </div>
            </div>
            <div class="order-item"
                 @click="toOrder(3)">
                <img src="~@/assets/imgs/my_daic.png"
                     class="order-item-image" />
                <div class="order-item-title">已出票</div>
                <div class="order-item-num"
                     v-if="orderNum.drawed&&(orderNum.drawed > 0)">
                    {{orderNum.drawed}}
                </div>
            </div>
            <div class="order-item"
                 @click="toOrder(4)">
                <img src="~@/assets/imgs/my_yic.png"
                     class="order-item-image" />
                <div class="order-item-title">已取消</div>
            </div>
        </div>
        <template v-if="!isVisitor">
            <div class="view20"></div>
            <div class="line"
                 v-if="isSupplier">
                <div class="line-title">新订单通知</div>
                <div class="line-value">
                    <div class="switch"
                         @click="clickSwitchEnableMpNotify"
                         :class="{'active' : enableMpNotify}"></div>
                </div>
            </div>
            <div class="line"
                 v-if="showReceiveOrderStatus">
                <div class="line-title">设置接单状态</div>
                <div class="line-value">
                    <img class="right"
                         src="~@/assets/icons/icon-right.png" />
                </div>
            </div>
            <div class="line"
                 @click="clickOther(setPassword)">
                <div class="line-title">设置密码</div>
                <div class="line-value">
                    <img class="right"
                         src="~@/assets/icons/icon-right.png" />
                </div>
            </div>
            <div class="line"
                 v-if="isSupplier"
                 @click="clickOther(realName)">
                <div class="line-title">实名认证</div>
                <div class="line-value">
                    <img class="right"
                         src="~@/assets/icons/icon-right.png" />
                </div>
            </div>
        </template>
    </div>
</template>
<script>
    import { PAGE_SET_PASSWORD, PAGE_ORDER_LIST, PAGE_CUSTOMER_SERVICE } from 'page';
    import { GET_ORDER_STATISTICS } from '@/api';
    export default {
        data() {
            return {
                isVisitor: true,
                userInfo: {
                },
                // 订单数量
                orderNum: {
                    canceled: 0,
                    drawed: 0,
                    waitDraw: 0
                },
                // 个人收益
                money: {},
                // 
                supplierObj: {},
                // 是否供应商
                isSupplier: '',
                // 供应商接单状态
                showReceiveOrderStatus: false,
                // 实名认证状态
                verified: false,
                // 新订单提醒
                enableMpNotify: false,
                setPassword: { path: PAGE_SET_PASSWORD },
                realName: { type: 2 }
            }
        },
        created() {
            this.init();
        },
        methods: {
            // 页面初始化
            init() {
                if (this.$store.state.user.token) {
                    this.$util.getUserInfo().then(res => {
                        if (res.success) {
                            this.isVisitor = false;
                            this.userInfo = res.data;
                            this.isSupplier = res.data.roles.indexOf('supplier');
                            this.getOrderInfo();
                            this.getYuer();
                            if (this.isSupplier) {
                                this.getSupplierInfo();
                            }
                        }
                    })
                }
                else {
                    this.isVisitor = true;
                    this.userInfo = {};
                    this.orderNum = {
                        canceled: 0,
                        drawed: 0,
                        waitDraw: 0
                    };
                }
            },

            // 获取供应商信息
            getSupplierInfo() {
                // 获取供应商
                this.$util.post('/api/supplier/getDrawSummary').then(res => {
                    if (res.success) {
                        this.supplierObj = res.data;
                    }
                });
                // 接单状态
                this.$util.get('/api/supplier/listAvailableReceiveOrderStatus').then(res => {
                    if (res.success) {
                        this.showReceiveOrderStatus = !!res.data.length;
                    }
                });
                // 新订单是否通知
                this.$util.get('/api/supplier/' + this.userInfo.userId).then(res => {
                    this.enableMpNotify = res.data.enableMpNotify;
                    this.verified = res.data.verified;
                });
            },
            // 获取个人收益
            getYuer() {
                this.$util.post('/api/commission/userSummary').then(res => {
                    this.money = res.data;
                });
            },
            // 切换新订单提醒
            clickSwitchEnableMpNotify() {
                this.$util.post('/api/supplier/updateIsEnableMpNotify', {
                    enableMpNotify: !this.enableMpNotify
                })
                    .then(res => {
                        if (res.success) {
                            this.init();
                        }
                    });
            },
            // 复制成功回调
            copySuccess() {
                this.$toast('复制成功');
            },
            // 获取订单统计信息
            getOrderInfo() {
                this.$util.post(GET_ORDER_STATISTICS).then(res => {
                    if (res.success) {
                        this.orderNum = res.data;
                    }
                })
            },
            // 用户登录
            userLogin() {
                if (
                    !this.$store.state.common.platformId && this.$store.getters.isWechatBrowser
                ) {
                    this.$util.wxMpLogin();
                } else {
                    this.$loginModel.open({
                        success: () => {
                            this.$toast('登录成功');
                            this.init();
                            this.$loginModel.close();
                        }
                    });
                }
            },
            // 点击其他页面
            clickOther(item) {
                if (item.type == 1) {
                    if (this.$store.state.user.token) {
                        this.$util.pageJump(PAGE_CUSTOMER_SERVICE);
                    }
                    else {
                        this.userLogin();
                    }
                }
                else if (item.type == 2) {
                    if (this.verified) {
                        return this.$toast('您已实名认证，无需再次认证');
                    } else {
                        window.location.href = `${window.location.origin}/real-name-auth/auth/index.html?source=h5&token=${this.$$store.common.token}`;
                    }
                }
                else if (item.path) {
                    this.$util.pageJump(item.path)
                }
            },
            // 去我的订单
            toOrder(type) {
                this.$util.pageJump(PAGE_ORDER_LIST, {
                    type
                })
            },
            // 清除缓存
            clearToken() {
                if (this.$store.state.common.env != 'PRO') {
                    this.$store.commit('clearToken');
                    this.init();
                }
            },
        }
    }
</script>
<style lang="less" scoped>
    @import url('~@/lib/base.less');

    .page-my {
        background: #fff;
        min-height: 100vh;
        box-sizing: border-box;
        .header {
            width: 100%;
            background: #ffdb29;
            .user-info {
                padding-top: .pxToRem(40) [];
                padding-left: .pxToRem(30) [];
                padding-bottom: .pxToRem(30) [];
                height: .pxToRem(124) [];
                .avatar {
                    display: inline-block;
                    position: relative;
                    .avatar-img {
                        .sq(116);
                        border-radius: 50%;
                        border: .pxToRem(4) [] solid #ccaf21;
                    }
                }
                .h-user {
                    float: right;
                    width: .pxToRem(556) [];
                    height: .pxToRem(124) [];
                    color: #000000;
                    font-size: .pxToRem(38) [];
                    line-height: .pxToRem(124) [];
                    font-weight: bold;
                    .user-name {
                        font-weight: bold;
                        font-size: .pxToRem(38) [];
                        line-height: .pxToRem(38) [];
                        margin: .pxToRem(17) [] 0 .pxToRem(27) [];
                        .user-level {
                            display: inline-block;
                            background-color: #000;
                            border-radius: .pxToRem(35) [];
                            color: #be985d;
                            font-size: .pxToRem(20) [];
                            line-height: .pxToRem(35) [];
                            padding: 0 .pxToRem(15) [];
                            font-weight: normal;
                            vertical-align: .pxToRem(5) [];
                        }
                        .image2 {
                            width: .pxToRem(32) [];
                            height: .pxToRem(18) [];
                            vertical-align: .pxToRem(-2) [];
                            margin-right: .pxToRem(5) [];
                        }
                    }
                    .user-id {
                        font-weight: 400;
                        font-size: .pxToRem(26) [];
                        line-height: .pxToRem(26) [];
                    }
                }
            }
            .earnings {
                padding-top: .pxToRem(40) [];
                padding-bottom: .pxToRem(30) [];
                display: flex;
                width: 100%;
                justify-content: space-around;
                flex-wrap: nowrap;
                .earnings-item {
                    height: .pxToRem(88) [];
                    text-align: center;
                    .earnings-item-value {
                        font-size: .pxToRem(46) [];
                        font-weight: bold;
                        line-height: .pxToRem(34) [];
                        margin-bottom: .pxToRem(20) [];
                        position: relative;
                    }
                    .earnings-item-title {
                        font-size: .pxToRem(26) [];
                        line-height: .pxToRem(26) [];
                    }
                }
            }
        }
        .view20 {
            width: 100%;
            height: .pxToRem(20) [];
            background: #f5f5f5;
        }
        .order-title {
            position: relative;
            height: .pxToRem(100) [];
            line-height: .pxToRem(100) [];
            padding: 0 .pxToRem(24) [] 0 .pxToRem(30) [];
            font-weight: bold;
            font-size: .pxToRem(32) [];
            color: #000;
            .order-all {
                float: right;
                font-weight: normal;
                font-size: .pxToRem(28) [];
                color: #b3b3b3;
                .order-all-you {
                    width: .pxToRem(10) [];
                    height: .pxToRem(16) [];
                    margin-left: .pxToRem(9) [];
                }
            }
            &:after {
                content: ' ';
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                height: .pxToRem(1) [];
                background: #ebeef0;
            }
        }
        .order-list {
            height: .pxToRem(150) [];
            display: flex;
            width: 100%;
            justify-content: space-around;
            .order-item {
                height: .pxToRem(150) [];
                text-align: center;
                position: relative;
                .order-item-image {
                    .sq(60);
                    margin-top: .pxToRem(30) [];
                }
                .order-item-title {
                    color: #666666;
                    font-size: .pxToRem(26) [];
                    white-space: nowrap;
                }
                .order-item-num {
                    position: absolute;
                    .sq(30);
                    line-height: .pxToRem(30) [];
                    text-align: center;
                    background-color: #ff4343;
                    border-radius: 50%;
                    font-size: .pxToRem(20) [];
                    color: #fff;
                    top: .pxToRem(17) [];
                    right: .pxToRem(-10) [];
                }
            }
        }
        .line {
            display: flex;
            justify-content: space-between;
            height: .pxToRem(94) [];
            line-height: .pxToRem(94) [];
            padding: 0 .pxToRem(24) [] 0 .pxToRem(30) [];
            font-size: .pxToRem(32) [];
            border-bottom: .pxToRem(1) [] solid #ebeef0;
            .line-title {
                font-weight: bold;
            }
            .line-value {
                .right {
                    .base-center-y;
                    right: 0;
                    .sq(32);
                }
                .switch {
                    .base-center-y;
                    right: 0;
                    width: .pxToRem(96) [];
                    height: .pxToRem(52) [];
                    border-radius: .pxToRem(26) [];
                    background: rgba(0, 0, 0, 0.1);
                    transition: all 0.3s;
                    &.active {
                        background: @theme_color_first;
                        &:after {
                            left: .pxToRem(46) [];
                        }
                    }
                    &::after {
                        content: ' ';
                        .base-center-y;
                        left: .pxToRem(2) [];
                        .sq(48);
                        border-radius: 100%;
                        background: white;
                        transition: all 0.2s;
                    }
                }
            }
        }
    }
</style>
